export const environment = {
  tag: 'PROD',
  localStoragePrefix: 'paades_',
  production: true,
  clientId: 'unesp.posgrad-paades',
  name: 'PROPG - Pró-reitoria de Pós-graduação',
  baseUrlApi: 'https://app.unesp.br/paades-api',
  baseUrlRedirect: 'https://app.unesp.br/paades/auth/',
  oauthAuthorize: 'https://auth.unesp.br/oauth/authorize',
  centralRolePrefix: 'ROLE_UNESP.POSGRAD-PAADES_',
  refreshTokenExpirationInSeconds: 3600,
  refreshTokenExpirationActivityNotificationsTime: [1800, 600, 300, 180, 120],
  refreshTokenExpirationLastWarningTime: 61,
  roles: {
    DISCENTE: {
      name: 'ROLE_UNESP.POSGRAD-PAADES_DISCENTE',
      desc: 'DISCENTE',
    },
    DOCENTE: {
      name: 'ROLE_UNESP.POSGRAD-PAADES_DOCENTE',
      desc: 'DOCENTE',
    },
    DEPARTAMENTO: {
      name: 'ROLE_UNESP.POSGRAD-PAADES_DEPARTAMENTO',
      desc: 'DEPARTAMENTO',
    },
    STPG: {
      name: 'ROLE_UNESP.POSGRAD-PAADES_STPG',
      desc: 'STPG',
    },
    PROPG: {
      name: 'ROLE_UNESP.POSGRAD-PAADES_PROPG',
      desc: 'PROPG',
    },
    ASSESSOR: {
      name: 'ROLE_UNESP.POSGRAD-PAADES_ASSESSOR',
      desc: 'ASSESSOR',
    },
    CONSULTA: {
      name: 'ROLE_UNESP.POSGRAD-PAADES_CONSULTA',
      desc: 'CONSULTA',
    },
  },
  servicedesk: 'https://servicedesk.unesp.br/portfolio/runesp/paades',
  centralAcessos: 'https://sistemas.unesp.br/central/',
  recaptcha: {
    siteKey: '6Lch0Z0jAAAAAJFxpMZWyH9bWDOM_UePhXbhwW2X',
  },
}
